import { render, staticRenderFns } from "./ProductionSnapshot.vue?vue&type=template&id=9d582db0"
import script from "./ProductionSnapshot.vue?vue&type=script&lang=js"
export * from "./ProductionSnapshot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d582db0')) {
      api.createRecord('9d582db0', component.options)
    } else {
      api.reload('9d582db0', component.options)
    }
    module.hot.accept("./ProductionSnapshot.vue?vue&type=template&id=9d582db0", function () {
      api.rerender('9d582db0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/ProductionSnapshot.vue"
export default component.exports